/**
 * @file The Groups page keeps which section is open in its query string, so the browser's Back
 * returns from the editor to the list. `?group=<pkid>` edits that group (the link the Templates
 * page already sends), `?section=edit` creates one, and no query is the list.
 */

export type GroupsPage =
  | { section: 'list' }
  | { section: 'edit'; groupPkid: number }
  | { section: 'create'; templatePkid: number | null }

/** A positive integer pkid from a query value; a UUID or anything else is null. */
export function queryPkid(value: unknown): number | null {
  if (typeof value !== 'string' || !/^[1-9]\d*$/.test(value)) return null
  const pkid = Number(value)
  if (!Number.isSafeInteger(pkid) || String(pkid) !== value) return null

  return pkid
}

export function pageFromQuery(query: Record<string, unknown>): GroupsPage {
  const groupPkid = queryPkid(query.group)
  if (groupPkid !== null) return { section: 'edit', groupPkid }
  if (query.section === 'edit') {
    return { section: 'create', templatePkid: queryPkid(query.template) }
  }

  return { section: 'list' }
}

export function queryFromPage(page: GroupsPage): Record<string, string> {
  if (page.section === 'edit') return { group: String(page.groupPkid) }
  if (page.section === 'create') {
    return page.templatePkid === null
      ? { section: 'edit' }
      : { section: 'edit', template: String(page.templatePkid) }
  }

  return {}
}
